<lxm-dialog [dialogRef]="dialogRef" [formGroup]="formGroup">
  <span header-title>{{
    "cards.products.confirmed_products_report_dialog.title" | translate
  }}</span>

  <div body>
    <p
      class="mb30 mt15 font-text text-sm font-normal text-dirtyPurple"
      [innerHTML]="'cards.products.confirmed_products_report_dialog.info_text' | translate"
    ></p>

    <form-field
      dialog
      for="from"
      [required]="true"
      label="cards.products.confirmed_products_report_dialog.label.period"
    >
      <div any class="date-range confirmed-products-report-dialog__period">
        <lxm-datepicker
          for="from"
          class="f-1"
          placeholder="cards.products.confirmed_products_report_dialog.label.date_from"
          [max]="formGroup.get('to').value"
        ></lxm-datepicker>
        <div class="date-range__separator">-</div>
        <lxm-datepicker
          for="to"
          class="f-1"
          placeholder="cards.products.confirmed_products_report_dialog.label.date_to"
          [min]="formGroup.get('from').value"
        ></lxm-datepicker>
      </div>
    </form-field>
  </div>

  <section footer>
    <lxm-button
      type="primary"
      label="cards.products.confirmed_products_report_dialog.submit"
      [disabled]="formGroup.invalid"
      (click)="submit()"
    ></lxm-button>

    <lxm-button
      type="tertiary"
      label="action.cancel"
      (click)="closeDialog()"
    ></lxm-button>
  </section>
</lxm-dialog>
